<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">{{ label }}{{ required ? ' *' : '' }}</label>
        </div>
        <div class="field-body">
            <div
                class="field"
                :class="{ 'has-addons': staticRight }"
            >
                <div
                    class="control"
                    :class="{ 'has-icons-left': isMoney }"
                >
                    <template v-if="!$slots.custom">

                    <template v-if="loading">
                    <span
                        :id="id"
                        class="input input-loading"
                        :class="inputClass"
                        v-bind="$attrs"
                    />
                    </template>
                    <template v-else>
                    <input
                        v-if="type === 'text' || type === 'email' || type === 'time'"
                        :type="type"
                        :placeholder="placeholder"
                        :id="id"
                        class="input"
                        :class="[inputClass, {readonly}]"
                        :readonly="readonly"
                        :value="myValue"
                        v-bind="$attrs"
                        @input="onInput"
                    >
                    <input
                        v-if="type === 'number'"
                        type="text"
                        :placeholder="placeholder"
                        :id="id"
                        class="input"
                        :class="[inputClass, {readonly}]"
                        :readonly="readonly"
                        v-bind="$attrs"
                        :value="myValue"
                        @input="onInput"
                        @change="onInput"
                        inputmode="numeric"
                        pattern="[0-9]*"
                    >
                    <input
                        v-if="type === 'checkbox'"
                        type="checkbox"
                        :id="id"
                        :class="[inputClass, {readonly}]"
                        :disabled="readonly"
                        :checked="myValue"
                        :value="value"
                        v-bind="$attrs"
                        style="margin-top: 18px"
                        @input="onInput"
                        @change="onInput"
                    >
                    <textarea
                        v-if="type === 'textarea'"
                        :placeholder="placeholder"
                        :id="id"
                        class="textarea"
                        :class="[inputClass, {readonly}]"
                        :readonly="readonly"
                        :value="myValue"
                        v-bind="$attrs"
                        @input="onInput"
                        @change="onInput"
                    ></textarea>
                    <div
                        v-if="type === 'div'"
                        :id="id"
                        class="input"
                        :class="inputClass"
                        v-bind="$attrs"
                        v-text="value"
                    ></div>

                    <span class="icon is-small is-left" v-if="isMoney">
                        <i class="fas fa-dollar-sign"></i>
                    </span>
                    </template>
                    </template>

                    <div
                        :class="inputClass"
                        style="border: none; box-shadow: none;"
                        v-else
                    >
                        <slot name="custom"></slot>
                    </div>
                </div>
                <div class="control" v-if="staticRight">
                    <a class="button is-static">{{ staticRight }}</a>
                </div>
                <p
                    class="help is-info"
                    v-if="info"
                    v-html="info"
                    style="line-height: 1;"
                />
                <p
                    class="help is-danger"
                    v-if="validator && validator.$dirty && validator.$invalid"
                >
                    {{ errorMessage }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
        placeholder: {
            type: String,
            default: '',
        },
        isMoney: {
            type: Boolean,
            default: false,
        },
        staticRight: {
            type: String,
            default: '',
        },
        inputClass: {
            type: Array,
            default() { return []; },
        },
        value: {
            type: [Number, String, Boolean],
            default: '',
        },
        validator: {
            type: Object,
            default: null,
        },
        info: {
            type: String,
        },
        errorCond: {
            type: Boolean,
            default: true,
        },
        errorMessage: {
            type: String,
            default: '',
        },
        events: {
            type: Array,
            default() { return []; },
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            myValue: this.value,
        }
    },
    watch: {
        value(cur, prev) {
            this.myValue = cur;
        },
    },
    methods: {
        onInput($event) {
            this.validator && this.validator.$touch();
            this.myValue = this.type === 'checkbox' ? $event.target.checked : $event.target.value;
            this.$emit('input', this.myValue);
        },
    }
}
</script>

<style>
.autoHeight {
    height: unset;
}
.input-loading {
    background-color: #dddddd;
    position: relative;
    overflow: hidden;
    display: inline-block;
}
.input-loading::before {
    content: '';
    display: block;
    position: absolute;
    left: -150px;
    top: 0;
    height: 100%;
    width: 150px;
    background: linear-gradient(to right, transparent 0%, #eeeeee 50%, transparent 100%);
    animation: load 1.5s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;
}
@keyframes load {
    from {
        left: -150px;
    }
    to   {
        left: 100%;
    }
}
input.readonly, textarea.readonly {
    border-color: transparent !important;
}
</style>
